import React from 'react';

import { formatToFixedMoneyWithLocale } from 'Helpers/formatService';

import ModalFooter from 'CommonComponents/ModalFooter';
import ModalHeader from 'CommonComponents/ModalHeader';

const PurchaseRequisitionProcurementMethodModal = (props) => {
    const submitRequest = () => {
        props.triggerAction && typeof props.triggerAction === 'function' && props.triggerAction();
    };

    const internalCloseHandler = () => {
        props.cleanStates && typeof props.cleanStates === 'function' && props.cleanStates();
        props.closeHandler && typeof props.closeHandler === 'function' && props.closeHandler();
    };

    const internalSuccessHandler = () => {
        props.cleanStates && typeof props.cleanStates === 'function' && props.cleanStates();
        props.successHandler && typeof props.successHandler === 'function' && props.successHandler();
    };

    const close = () => {
        if (props.actionCompleted || props.actionFailed) {
            internalSuccessHandler();
        } else {
            internalCloseHandler();
        }
        props.modalElement.hide();
    };

    return (
        <div
            id={props.modalId}
            ref={props.modalRef}
            tabIndex="-1"
            aria-hidden="true"
            className="hidden modal__box tw-z-[75] tw-backdrop-blur-sm tw-bg-charcoal-50/30"
        >
            <div className="modal__container">
                <div className="modal__inner-container">
                    <ModalHeader title={$t(props.title)} close={close}></ModalHeader>
                    <div className="tw-rounded-b">
                        {props.allowAction && (
                            <div className="modal__form-container">
                                {!props.actionCompleted && !props.actionFailed && (
                                    <>
                                        <div className="inbud-table_wrapper">
                                            <table className="inbud-table">
                                                <thead>
                                                    <tr>
                                                        <th>{$t('Value')}</th>
                                                        <th>{$t('Method')}</th>
                                                        <th>{$t('Details')}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {(Array.isArray(props.policies) ? props.policies : []).map((policy) => {
                                                        return (
                                                            <tr key={`Policy ${policy.id}`}>
                                                                <td>
                                                                    {Number(policy.total_cost)
                                                                        ? formatToFixedMoneyWithLocale(policy.total_cost)
                                                                        : policy.total_cost}
                                                                </td>
                                                                <td>{policy.method}</td>
                                                                <td>{policy.details}</td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                        <ModalFooter
                                            allowSubmit={false}
                                            cancelButtonText={$t(props.cancelButtonText)}
                                            primaryButtonText={$t(props.primaryButtonText)}
                                            onCancel={close}
                                            handleSubmit={submitRequest}
                                            isSubmitting={props.request}
                                        ></ModalFooter>
                                    </>
                                )}
                                {props.actionCompleted && (
                                    <div className="tw-grid tw-grid-cols-1">
                                        <p className="modal__msg modal__text-color">{props.actionCompletedMsg}</p>
                                    </div>
                                )}
                                {props.actionFailed && (
                                    <div className="tw-grid tw-grid-cols-1">
                                        <p className="modal__msg modal__error-text-color">{props.actionFailedMsg}</p>
                                    </div>
                                )}
                                {(props.actionCompleted || props.actionFailed) && (
                                    <div className="modal__footer">
                                        <button type="button" className="btn-danger" onClick={internalSuccessHandler}>
                                            {$t('Close')}
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(PurchaseRequisitionProcurementMethodModal);
